<template>
    <div>
        <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn @click="convertPlaceholders(measures.items, instrument_data.family)" color="primary">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.rif }}</th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.mass }} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.reading }} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.mpe}}<br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{ data.block.conf.headers.result }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measures.items" :key="index">
                                <td class="table-blocks d-flex align-center">
                                    <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings" @click="removeRow(index)">delete</v-icon>
                                    <div v-else class="d-flex pr-4"></div>
                                    <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{item.rif}}</div>
                                </td>
                                <td class="table-blocks">
                                    <NumericField dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        v-model="item.mass"
                                        :class="readingWarning(item.mass)"
                                        :precision="currentPrecision"
                                    />
                                </td>
                                <td class="table-blocks">
                                    <NumericField
                                        dense outlined
                                        solo hide-details
                                        :readonly="preview"
                                        :placeholder="readingPlaceholder(item.mass)"
                                        v-model="item.reading"
                                        :class="readingWarning(item.reading)"
                                        :precision="currentPrecision"
                                        :enableicons="!preview"
                                        :addfunc="readingAddFunc"
                                        :subfunc="readingSubFunc"
                                        :row="item"
                                        :fieldname="'reading'"
                                        :range="calcMinRange(item.reading)"
                                    />
                                </td>
                                <td class="table-text-blocks text-right"><b >{{item.error | formatNumber}}</b></td>
                                <td class="table-text-blocks text-right"><b>{{item.mpe}}</b></td>
                                <td class="table-text-blocks text-right">
                                    <StatusIcon
                                        :status="item.result"
                                        :tooltip_text="row_tooltip[item.result]" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                </div>        
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow()"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            </v-container>                
            </div>
        </LayoutBlock>
        
    </div>
</template>
<script>
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {BaseIsoSimple} from "../../../utils/baseIsoSimple"
import {comparison_item} from "../../../utils/itemBlockSchema"
import Big from "big.js"

export default {
    mixins: [BaseIsoSimple],
    components: {LayoutBlock, StatusIcon},
    methods:{
        async buildMeasures(){
            this.measures = {
                items: [],
                hi_res: 'off',
                result: 'uncomplete'
            }
            let valuesFromCategory = await this.buildWithCategory()
            if(valuesFromCategory){
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow(valuesFromCategory[i])
                } 
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++){
                    this.addRow()
                }
            }
        },
        addRow(nom_value = null){
            let item = comparison_item({
                rif: this.measures.items.length + 1,
                mass: nom_value,
            })
            this.measures.items.push(item)
        },
        calculateMPE(val){
            let range = this.calcMinRange(val)
            let min_div = this.instrument_data.instrument_class ? Big(range.e) : Big(range.d)
            return this.round(min_div.times(20))
        },
        calcError(row){
            if(row.reading != null && row.reading != '' && row.mass != null && row.mass != ''){
                row.mpe = this.calculateMPE(row.reading)
                row.error = this.round(this.differenceInt(row.mass, row.reading), this.currentPrecision)
                this.calculateResult(row)
            } else {
                row.result = "uncomplete"
            }
        },
        calcDiff(){
            console.log("pippo activated")
            for(let item of this.measures.items){
                this.calcError(item)
            }
            this.calcBlockResult()
        }
        
    },

}
</script>